import AnalyticsService from 'services/AnalyticsLite/AnalyticsService'
import Logger from 'services/Logger'
import { EmbedEvent } from './types'
import { ga4Client } from 'services/AnalyticsLite/GA4/utils/client'
import { ID } from 'lib'

const context: Record<string, any> = {}

const hacks = (data: Record<string, any>) => {
	if (data.pcmPixelPostMessageEvent) {
		const event = data.pcmPixelPostMessageEvent.ev
		// eslint-disable-next-line sonarjs/no-small-switch
		switch (event) {
			case 'result-offer-click':
				const value = JSON.parse(data.pcmPixelPostMessageEvent.cd)
				const offer = JSON.parse(value.offer)
				const clickedOfferUuid = offer.uuid
				const clickedOfferObject = context.loanOffers.find((o: any) => o.uuid === clickedOfferUuid)
				const lender = clickedOfferObject?.originator?.key
				Object.assign(context, { lenderClicked: lender })
				break
		}
	}
}

// eslint-disable-next-line sonarjs/cognitive-complexity
export const handleEmbedEvent = (e: MessageEvent): void => {
	try {
		if (e.origin === 'https://embed.hifiona.com') {
			hacks(e.data)
			const message: EmbedEvent = e.data.body ? JSON.parse(e.data.body) : undefined
			// if (message?.leadUuid) AnalyticsService.identify(message.leadUuid)
			switch (e.data.type) {
				case 'fiona_impression':
					AnalyticsService.track('embed_impression', {
						category: message.product,
						label: message.trackingUuid
					})
					break
				case 'fiona_appLoaded':
					AnalyticsService.track('application_started', {
						category: message.product,
						label: message.applicationStep
					})
					break
				case 'fiona_previewOffersRender':
					AnalyticsService.track('preview_offers_shown', {
						category: message.product,
						label: message.applicationStep
					})
					break
				case 'fiona_applicationStepSelected':
					AnalyticsService.track('step_selected', {
						category: message.product,
						label: message.applicationStep
					})
					break
				case 'fiona_appComplete':
					AnalyticsService.track('application_submitted', {
						category: message.product,
						label: message.applicationStep
					})
					break
				case 'fiona_rate_table_uuid':
					AnalyticsService.track('ratetable_created', {
						category: message.product,
						label: message.rateTableUuid
					})
					//TODO: Fix
					//message.rateTableUuid && createSearchFromRateTable(message.rateTableUuid)
					break
				case 'fiona_ratetableRender':
					const offers = message.data?.loanOffers
					Object.assign(context, { loanOffers: offers })
					AnalyticsService.track('ratetable_rendered', {
						category: message.product,
						label: message.trackingData?.uuid || ''
					})
					break
				case 'fiona_specialOfferClick':
					AnalyticsService.track('special_offer_click', {
						category: 'loan',
						label: 'special_offer',
						value: (message.lead?.recScore || 0) / 100
					})

					ga4Client.eventsClient.trackPurchase(ID(), 'loan_offer_click', (message.lead?.recScore || 0) / 100)

					break
				case 'fiona_loanOfferClick':
					ga4Client.eventsClient.trackPurchase(ID(), 'loan_offer_click', (message.lead?.recScore || 0) / 100)
					break
				case 'fiona_loanOfferAutoRedirect':
					AnalyticsService.track('offer_auto_redirect', {
						category: 'loan',
						label: message.trackingData?.offerType,
						property: message.offer?.name,
						value: (message.offer?.recommendationScore || 0) / 100
					})
					break
				case 'fiona_creditCardOfferClick':
					AnalyticsService.track('credit_card_offer_click', {
						category: 'credit_card',
						label: message.lead?.uuid,
						value: message.lead?.recScore || 0
					})
					break
				case 'fiona_lifeInsuranceOfferClick':
					AnalyticsService.track('life_insurance_offer_click', {
						category: 'life_insurance',
						label: message.lead?.uuid,
						value: message.lead?.recScore || 0
					})
					break
				case 'fiona_lifeInsurancePhoneCallRequested':
					AnalyticsService.track('life_insurance_call_requested', {
						category: 'life_insurance',
						label: message.lead?.uuid,
						value: message.lead?.recScore || 0
					})
					break
			}
		}
	} catch (ex) {
		Logger.error('Error sending embed event', { message: ex })
	}
}
